import React from "react";
import styles from "./Accommodation.module.css";
import VenuesMap from "../../components/VenuesMap";
import HotelCard from "../../components/HotelCard";

const Accommodation: React.FC = () => {
  return (
    <>
      <section className="container">
        <div className="pageTitle">Where to Stay</div>
        <div className="blurb">
          We're so excited to have you join us in Austin! Whether you're visiting from out of town or
          looking for a convenient place to stay, we've put together some helpful information about
          accommodations near our wedding venues. Austin has so much to offer, and we want to make
          sure you have the perfect home base for your visit.
        </div>
        <div className="blurb">
          The map below highlights some key locations including the church and reception venues, as well as our recommended hotel block.
        </div>
      </section>
      <VenuesMap className={styles.mapContainer} />
      <section className="container">
        <div className="pageTitle">Hotel Blocks</div>
        <div className={styles.hotelsGrid}>
          <HotelCard
            hotelName="Hampton Inn Austin NW near The Domain"
            address="3908 West Braker Lane, Austin, TX 78759 USA"
            phone="+1 512-349-9898"
            bookingUrl="https://www.hilton.com/en/attend-my-event/ausnwhx-902-232a563b-2e3a-44cf-b228-ba1146344285/"
            eventDates="March 13, 2026 - March 15, 2026"
            bookByDate="February 15, 2026"
            rooms={[
              {
                type: "2 Queen Beds Nonsmoking",
                price: "$139.73"
              },
              {
                type: "1 King Bed Study with Sofabed Nonsmoking",
                price: "$139.73"
              }
            ]}
          />
          <HotelCard
            hotelName="Hampton Inn Austin East Side 5th Street"
            address="2033 E. 5th Street, Austin, Texas 78702-4525 USA"
            phone="+1-800-HAMPTON"
            bookingUrl="https://www.hilton.com/en/book/reservation/rooms/?ctyhocn=AUSEAHX&arrivalDate=2026-03-13&departureDate=2026-03-15&groupCode=CHH900&room1NumAdults=1&cid=OM%2CWW%2CHILTONLINK%2CEN%2CDirectLink"
            eventDates="March 13, 2026 - March 15, 2026"
            bookByDate="February 15, 2026"
            rooms={[
              {
                type: "1 King With Microwave And Fridge",
                price: "$305.00"
              },
              {
                type: "2 Queens With Microwave And Fridge",
                price: "$305.00"
              }
            ]}
          />
        </div>

        <div className={styles.airbnbSection}>
          <div className="pageTitle">AirBnb Options</div>
          <div className="blurb">
            Looking for something a bit more homey? Need extra space for the whole crew to bunk down together? We've put together a ripper collection of Airbnbs that'll give you more room to spread out and make yourselves at home. Perfect for families or groups who want to stick together!
          </div>
          <div className="blurb">
            While these are AirBnb's we think you will love, feel free to choose something close to any of these locations. The general areas near the venue are Springdale and East Austin; a little further out but with good activities are North Austin or North Loop.
          </div>

          <div className={styles.airbnbLink}>
            <a
              href="https://www.airbnb.com/wishlists/viewonly/141772bd-53d5-40fe-a00f-b95d4fa74293?s=67&unique_share_id=a16e1efd-3035-41af-abe5-673bbffad191"
              target="_blank"
              rel="noopener noreferrer"
              className="primary-btn"
            >
              Browse Our Airbnb Collection
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Accommodation;
